import moment from 'moment';
import { rangeInteract } from '../TimeLinePicker/util';
export const fixNumber = (num) => {
    return `${num < 10 ? '0' : ''}${num}:00`;
};
export const sortByFreeBusy = (formStart, formEnd, userFreeBusyNotSort) => {
    if (userFreeBusyNotSort && userFreeBusyNotSort.length > 1) {
        const first = userFreeBusyNotSort[0];
        const busyArr = [];
        const freeArr = [];
        userFreeBusyNotSort.forEach((item, idx) => {
            if (idx) {
                let busy = false;
                if (formStart && formEnd) {
                    for (let i = 0; i < item.freeBusyItems.length; i++) {
                        const element = item.freeBusyItems[i];
                        busy = rangeInteract([moment(element.start), moment(element.end)], [formStart, formEnd]) !== null;
                        if (busy) {
                            break;
                        }
                    }
                }
                if (busy) {
                    busyArr.push(item);
                }
                else {
                    freeArr.push(item);
                }
            }
        });
        return [first, ...busyArr, ...freeArr];
    }
    else {
        return userFreeBusyNotSort;
    }
};
